import React, { useState, useEffect, Children, cloneElement } from "react";

const ImageLoader = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const images = [];
    const imagePromises = [];

    const findImages = (element) => {
      if (
        !element ||
        typeof element === "string" ||
        typeof element === "number"
      ) {
        return;
      }
      if (element.type === "img") {
        images.push(element.props.src);
      } else if (element.props && element.props.children) {
        Children.forEach(element.props.children, findImages);
      }
    };

    Children.forEach(children, findImages);
    if (images.length === 0) {
      setLoading(false);
      return;
    }
    images.forEach((src) => {
      const promise = new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = reject;
      });
      imagePromises.push(promise);
    });

    Promise.all(imagePromises)
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading images", err);
        setLoading(false);
      });
  }, [children]);

  const renderChildren = (elements) => {
    return Children.map(elements, (child) => {
      if (
        !child ||
        typeof child === "string" ||
        typeof child === "number"
      ) {
        return child;
      }
      if (child.type.name === "AnimateOnScroll") {
        return cloneElement(child, { imagesLoaded: !loading });
      }
      if (child.props && child.props.children) {
        return cloneElement(child, {
          children: renderChildren(child.props.children),
        });
      }
      return child;
    });
  };

  return <>{renderChildren(children)}</>;
};

export default ImageLoader;
